import { getEnv } from '~/utils';

export function getAppLinkMissionExpired(): string | undefined {
  return getEnv('NEXT_PUBLIC_APP_LINK_MISSION_EXPIRED');
}

export function getAppLinkMissionApplied(): string | undefined {
  return getEnv('NEXT_PUBLIC_APP_LINK_MISSION_APPLIED');
}
